class ModalDialog extends HTMLElement {
  constructor() {
    super()

    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false))

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })

    this.addEventListener('click', (event) => {
      if (event.target === this) this.hide()
    })
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
  }
}

customElements.get('modal-dialog') || customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')

    if (!button) return;
    button.addEventListener('click', (e) => {

      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    });
  }
}
customElements.get('modal-opener') || customElements.define('modal-opener', ModalOpener)

